// @ts-check

const MAX_DIRS = 4;
const LEADING_DIRS = 1;
const TAILING_DIRS = 2;

/**
 * @typedef {Object} BreadcrumbsProps
 * @prop {(n: number, id: string, type: string) => void} onUp
 * @prop {string[]} path
 * @prop {Record<string, any>} objects
 * @prop {string} toplevel
 *
 * @param {BreadcrumbsProps} props
 */
export default function BreadCrumbs(props) {
    return (
        <ul className='navcrumb'>
            <li>
                <button onClick={() => props.onUp(props.path.length, props.toplevel, 'toplevel')}>
                    {props.toplevel}
                </button>
            </li>
            {props.path.map((id, i) => {
                if (props.path.length >= MAX_DIRS) {
                    if (i === LEADING_DIRS) {
                        return (
                            <li key={i} className='placeholder'>
                                <span>...</span>
                            </li>
                        );
                    } else if (i > LEADING_DIRS && i < props.path.length - TAILING_DIRS) {
                        return null;
                    }
                }

                return (
                    <li key={i}>
                        {props.path.length - 1 !== i ? (
                            <button
                                onClick={() => {
                                    props.onUp(
                                        props.path.length - i - 1,
                                        id,
                                        props.objects[id].type
                                    );
                                }}
                            >
                                {props.objects[id].name}
                            </button>
                        ) : (
                            <span>{props.objects[id].name}</span>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
